import { React, forwardRef } from "react"
import { TextField } from "formik-material-ui"
import { Formik, Field } from "formik"

import { Grid } from "@material-ui/core"
import { permisos } from "Components/Validation/Settings/Users/Permisos"

const Form = forwardRef((props, ref) => {
  const { onSubmit } = props

  return (
    <>
      <Formik
        initialValues={{
          descripcion: "",
        }}
        validationSchema={permisos}
        onSubmit={onSubmit}
      >
        {({ submitForm, isSubmitting }) => (
          <Grid container spacing={2}>
            <Grid item sm={12} xs={12}>
              <div style={{ height: "70px" }}>
                <Field
                  component={TextField}
                  fullWidth
                  label="Nombre del permiso"
                  name="descripcion"
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  inputProps={{
                    maxLength: 50,
                  }}
                />
              </div>
            </Grid>

            <button
              type="submit"
              onClick={submitForm}
              disabled={isSubmitting}
              ref={ref}
              style={{ display: "none" }}
            />
          </Grid>
        )}
      </Formik>
    </>
  )
})
export default Form
